import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../post_login/templates/header";

const ErrorPage = () => {
    const navigate = useNavigate();
    return (
        <div className="home_landing">
          {/* render header */}
          <Header />
              <div className="home_app">
                <div className="error_page-template">
                <div className="container center-content">
                <div className ="error-wrapper">
                    <div className="col-md-6 align-self-center">
                        <h1>Oops...</h1>
                        <h2>Looks like something was wrong.</h2>
                        <p>The resource you are looking for could not be found</p>
                            <button onClick={()=> navigate(-1)} className="verify_wrapper_form_btn_verify select success-btn"> Back </button>
                    </div>
                </div>
                </div>

                </div>
            </div>
        </div>
    )
}
export default ErrorPage
